import { api } from '@/services/api/AxiosBaseService'

export interface CatalogLocation {
  id: string
  name: string
  uf: string
}

/** Catálogo da rede credenciada (Links > Catálogo). */
export const CatalogService = {
  async states(): Promise<CatalogLocation[]> {
    const r = await api.get<{ data: CatalogLocation[] }>('/my-company/catalog/states')
    return r.data.data
  },
  async cities(stateId?: string): Promise<CatalogLocation[]> {
    const r = await api.get<{ data: CatalogLocation[] }>('/my-company/catalog/cities', {
      params: stateId ? { state_id: stateId } : {},
    })
    return r.data.data
  },
  async generate(mode: 'city' | 'state', ids: string[]): Promise<Blob> {
    const r = await api.post('/my-company/catalog/generate', { mode, ids }, { responseType: 'blob' })
    return r.data as Blob
  },
}
